

// A dictionary of available card sizes.
export const CARD_SIZES = [
    {
        label: 'Tiny (3x1.5)',
        value: "3,1.25",
    },
    {
        label: 'Little (4x1.5)',
        value: "4,1.25",
    },
    {
        label: 'Compact (6x1.5)',
        value: "6,1.25",
    },
    {
        label: 'Small (3x3)',
        value: "3,3",
    },
    {
        label: 'Medium (4x3)',
        value: "4,3",
    },
    {
        label: 'Large (6x3)',
        value: "6,3",
    },
    {
        label: 'Wide (8x3)',
        value: "8,3",
    },
    {
        label: 'Extra Wide (9x3)',
        value: "9,3",
    },
    {
        label: 'Full-Width (12x3)',
        value: "12,3",
    },
    {
        label: 'Narrow (3x6)',
        value: "3,6",
    },
    {
        label: 'Tall (4x6)',
        value: "4,6",
    },
    {
        label: 'Huge (6x6)',
        value: "6,6",
    },
    {
        label: 'Mega (8x6)',
        value: "8,6",
    },
    {
        label: 'Giant (9x6)',
        value: "9,6",
    },
    {
        label: 'Fullscreen (12x6)',
        value: "12,6",
    }
];


export const CARD_FOOTER_HEIGHT = 64;
export const CARD_HEADER_HEIGHT = 72;
